module.exports = __webpack_public_path__ + "img/168.ddb18dae.jpg";